import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith, tap } from "rxjs/operators";

export interface Option {
  id: number;
  name: string;
}

@Component({
  selector: "app-filter-object",
  templateUrl: "./filter-object.component.html",
  styleUrls: ["./filter-object.component.css"],
})
export class FilterObjectComponent implements OnInit {
  myControl = new FormControl();
  @Input() options: Option[] = [];
  @Input() disabledOpt: Option[] = [];
  @Input() placeholder: string = "";
  @Input() createOption: string = "";
  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
    this.onDisabledChange(value); // Llama a la lógica cuando cambia el valor
  }

  @Input() required: boolean = false;
  @Input() allOpt: boolean = false;
  @Input() value: number = null;
  @Output() selectChange: EventEmitter<Option>;
  @Output() valueChange: EventEmitter<string | null> = new EventEmitter(); // Nuevo evento
  filteredOptions: Observable<Option[]>;
  private _disabled: boolean = false; // Propiedad interna para el control del valor
  public create: Option;

  constructor() {
    this.selectChange = new EventEmitter();
  }
  get disabled(): boolean {
    return this._disabled; // Devuelve el valor actual
  }

  // Lógica que se ejecuta cuando cambia el valor de `disabled`
  onDisabledChange(isDisabled: boolean): void {
    if (isDisabled) {
      this.myControl.disable();
    } else {
      this.myControl.enable();
    }
    // Agrega aquí la lógica para activar o desactivar el componente
  }
  ngOnInit() {
    if (this.disabled) {
      this.myControl.disable();
    }
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith<string | Option>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filter(name) : this.options.slice()))
    );

    // Emitir el valor actual del campo al cambiar
    this.myControl.valueChanges.subscribe((value) => {
      if (value && typeof value === "object" && value.id) {
        this.valueChange.emit(value.id); // Emitir ID seleccionado
      } else if (typeof value === "string" && value.trim() === "") {
        this.valueChange.emit(null); // Emitir null si está vacío
      } /*else {
        this.valueChange.emit(value); // Emitir el texto
      }*/
    });

    this.create = {
      id: 0,
      name: "",
    };

    if (this.value !== null || this.allOpt) {
      for (let option of this.options) {
        if (option.id == this.value) {
          this.myControl.setValue(option);
          break;
        }
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["value"]) {
      console.log("Value updated:", this.value);
      /* this.setValue({ id: this.value, name: "" }); */
      // Aquí puedes realizar cualquier acción adicional
    }
  }

  unable(id) {
    return this.disabledOpt.includes(id);
  }

  displayFn(option?: Option): string | undefined {
    return option ? option.name : undefined;
  }

  private _filter(name: string): Option[] {
    const filterValue = name.toLowerCase();

    return this.options.filter((option) =>
      option.name ? option.name.toLowerCase().includes(filterValue) : null
    );
  }

  setValue(e: Option) {
    this.selectChange.emit(e);
  }
  onOptionSelected(value: Option) {
    this.selectChange.emit(value);
  }
}
